export default {
  'payment.submit': 'Submit',
  'payment.clear': 'Clear'
};
